window.bindSwipe = function (element, swipeLeft, swipeRight) {
    let touchX, touchY = 0;
    const grenzeHorizontal = 10;
    element.addEventListener('touchstart', (event) => {
        touchX = event.changedTouches[0].screenX;
        touchY = event.changedTouches[0].screenY;
    }, {passive: true});
    element.addEventListener('touchend', (event) => {
        let touchendX = event.changedTouches[0].screenX;
        let touchendY = event.changedTouches[0].screenY;
        let deltaX = touchendX - touchX;
        let deltaY = touchendY - touchY;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            let isLeftSwipe = deltaX < -1 * grenzeHorizontal;
            let isRightSwipe = deltaX > grenzeHorizontal;
            if (isLeftSwipe) {
                swipeLeft();
            } else if (isRightSwipe) {
                swipeRight();
            }
        }
    }, {passive: true});
}

window.bindArrowKeys = function (left, right) {
    document.addEventListener('keydown', (event) => {
        if (event.code === "ArrowLeft") {
            left()
        }
        if (event.code === "ArrowRight") {
            right()
        }
    }, false);
}
